<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('navigation.userTool') }}
            </h1>
        </el-row>
        <div class="el-main-content" v-show="!showCreateOrEditUserView">
            <stc-user-list></stc-user-list>
        </div>
        <div>
            <stc-dialog
                :title="userCreateEditTitle"
                v-model="permissions.includes('USER_WRITE') && showCreateOrEditUserView"
                @change="closeCreateBookingDialog"
            >
                <div class="el-main-content">
                    <stc-user-create
                        v-if="showCreateOrEditUserView"
                        :schedules="schedules"
                        :gates="gates"
                    ></stc-user-create>
                    <div class="el-grid-card">
                        <stc-container-permissions
                            v-if="showCreateOrEditUserView"
                            :key="componentKey"
                            :containers="containers"
                            :permissionsList="permissionsList"
                        ></stc-container-permissions>
                    </div>
                </div>
            </stc-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserList from '../../components/user-tool/UserList'
import UserCreate from '../../components/user-tool/UserCreate'
import ContainersAndPermissions from '../../components/user-tool/ContainerAndPermissions'
import StcDialog from '../../components/Dialog'

export default {
    name: 'user-tool',

    components: {
        'stc-user-list': UserList,
        'stc-user-create': UserCreate,
        'stc-container-permissions': ContainersAndPermissions,
        'stc-dialog': StcDialog,
    },

    data() {
        return {
            showCreateOrEditUserView: false,
            permissionsList: [],
            userCreateEditTitle: '',
            schedules: [],
            gates: [],
            componentKey: 0,
        }
    },

    created() {
        this.fetchPermissions()
        this.fetchSchedules()
        this.fetchGates()
        Events.$on('update-user-create-edit-title', val => {
            if (val) {
                this.userCreateEditTitle =
                    this.$t('form.title.create') +
                    ' ' +
                    this.$t('form.title.user')
            } else {
                this.userCreateEditTitle =
                    this.$t('form.title.update') +
                    ' ' +
                    this.$t('form.title.user')
            }
        })
        Events.$on('show-create-or-edit-view', val => {
            this.componentKey += 1
            this.showCreateOrEditUserView = false
            this.showCreateOrEditUserView = val
        })
    },

    beforeDestroy() {
        Events.$off('show-create-or-edit-view')
        Events.$off('update-user-create-edit-title')
    },

    computed: {
        ...mapGetters([
            'selectedContainer',
            'permissions',
            'containerTree',
            'containers',
        ]),
    },

    methods: {
        async fetchSchedules() {
                let { data } = await this.$http.get(
                    `/Container/${
                        this.selectedContainer.ContainerID
                    }/ScheduleTemplate`
                )
                data.sort( (a, b) => {
                    if(a && b && a.Description && b.Description){
                        return a.Description.localeCompare(b.Description, 'en', {numeric: true})
                    }
                });
                this.schedules = data
        },
        async fetchGates(container = null) {
            container = container || this.selectedContainer
            if (this.permissions.includes('CHECKPOINT_READ') && container) {
                let { data } = await this.$http.get(`/Checkpoint`);
                data.sort( (a, b) => {
                    if(a && b && a.Name && b.Name){
                        return a.Name.localeCompare(b.Name, 'en', {numeric: true})
                    }          
                });
                this.gates = data;
            }
        },
        async fetchPermissions() {
            let { data } = await this.$http.get('GetPermission')
            this.permissionsList = await this.groupByCategoryName(
                data,
                'Category',
                function(s, t) {
                    if (t.Values) {
                        t.Values.push(s.Description)
                    } else {
                        t.Values = []
                        t.Values.push(s.Description)
                    }
                }
            )
        },
        async groupByCategoryName(array, key, fn) {
            let hash = Object.create(null)
            return array.reduce(function(r, o) {
                if (!hash[o[key]]) {
                    hash[o[key]] = {}
                    hash[o[key]][key] = o[key]
                    r.push(hash[o[key]])
                }
                fn(o, hash[o[key]])
                return r
            }, [])
        },
        async closeCreateBookingDialog() {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.resetUser', {
                        section: this.$i18n.i18next.t('text.user'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                this.showCreateOrEditUserView = false
                return true
            } catch (e) {
                return false
            }
        },
    },
}
</script>
